import axios from 'axios'
import store from '@/store'

export default {

  async saveProductOptionImage(image) {
    let bodyFormData = new FormData()
    bodyFormData.append('file', image)
    try {
      let result = await axios.post(
        store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/product' ,
        bodyFormData,
        { headers: {'Content-Type': 'form-data' }}
      )
      if (result.data) {
        let imageName = result.data.file_name
        return imageName
      } else {
        return {error: true, msg: 'Erro ao realizar upload'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, msg: error.e.data.msg}
    }
  },

  async saveCoverPhotoImage(image) {
    let bodyFormData = new FormData()
    bodyFormData.append('file', image)
    try {
      let result = await axios.post(
        store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/path/cms' ,
        bodyFormData,
        { headers: {'Content-Type': 'form-data' }}
      )
      if (result.data) {
        let imageName = result.data.file_name
        return imageName
      } else {
        return {error: true, msg: 'Erro ao realizar upload'}
      }
    } catch (e) {
      console.log(e)
      return {error: true, msg: 'Erro ao realizar upload'}
    }
  },

  async saveMembershipImage(image) {
    let bodyFormData = new FormData()
    bodyFormData.append('file', image)
    try {
      let result = await axios.post(
        store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/path/membership_banners',
        bodyFormData,
        { headers: {'Content-Type': 'form-data' }}
      )
      if (result.data) {
        return {error: false, data:result.data.file_name, msg: 'Nota cadastrada com sucesso'}
      } else {
        return {error: true, msg: 'Erro ao realizar upload'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, msg: error.e.msg}
    }
  },

  async saveMembershipPrizeImage(image) {
    let bodyFormData = new FormData()
    bodyFormData.append('file', image)
    try {
      let result = await axios.post(
        store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/path/membership_prizes',
        bodyFormData,
        { headers: {'Content-Type': 'form-data' }}
      )
      if (result.data) {
        return {error: false, data:result.data.file_name, msg: 'Imagem salva com sucesso'}
      } else {
        return {error: true, msg: 'Erro ao realizar upload'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, msg: error.e.msg}
    }
  },

  async saveBlockImage (image) {
    let bodyFormData = new FormData()
    bodyFormData.append('file', image)
    try {
      let result = await axios.post(
        store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/path/block',
        bodyFormData,
        { headers: {'Content-Type': 'form-data' }}
      )
      if (result.data) {
        return {error: false, data:result.data.file_name, msg: 'Imagem salva com sucesso'}
      } else {
        return {error: true, msg: 'Erro ao realizar upload'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, msg: error.e.msg}
    }
  },

  async deleteMembershipScanImage (image) {
    let path = image.split('/')
    try {
      let result = await axios.delete(store.getters.getOpaApi + '/files/company/' + store.state.company.companyId + '/path/?path='+ path[path.length -3] + '/' + path[path.length -2] + '/' + path[path.length -1])
      if (result.data) {
        return result.data
      } else {
        return {error: true, msg: 'Erro ao remover nota'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, msg: error.e.msg}
    }
  }

}